/* eslint-disable no-underscore-dangle, no-param-reassign */
import wNumb from 'wnumb/wNumb';

const formatConfig = {
  decimals: 2,
  mark: ',',
  prefix: 'R$ ',
  thousand: '.',
};

class CurrencyFormatter {
  constructor() {
    this._formatter = wNumb(formatConfig);
  }

  format(value) {
    if (this.isStringValue(value)) {
      value = parseFloat(value);
    }
    return this._formatter.to(value);
  }

  isStringValue(value) {
    return typeof value === 'string';
  }
}

export default new CurrencyFormatter();
